import { render } from "./futuresData.vue?vue&type=template&id=ac0f999a&scoped=true"
import script from "./futuresData.vue?vue&type=script&lang=js"
export * from "./futuresData.vue?vue&type=script&lang=js"

import "./futuresData.vue?vue&type=style&index=0&id=ac0f999a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0f999a"]])

export default __exports__